import request from "./../utils/request";

export function getStatistics(data) {
    return request.post("/statistics", data);
}
